// The BE stores cutOffTime as a full timestamp whose time-of-day is what matters.
export const formatCutOffTime = (value: string | null | undefined): string => {
  if (!value) return '—';

  const date = new Date(value);
  if (isNaN(date.getTime())) return '—';

  return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
};

// "18:30" (from <input type='time'>) -> ISO timestamp on today's date, local time.
export const timeToIsoString = (time: string): string => {
  const [hours, minutes] = time.split(':').map(Number);
  const date = new Date();
  date.setHours(hours, minutes, 0, 0);
  return date.toISOString();
};

// ISO timestamp -> "18:30" for <input type='time'> prefill.
export const isoToTimeInput = (value: string | null | undefined): string => {
  if (!value) return '';

  const date = new Date(value);
  if (isNaN(date.getTime())) return '';

  return `${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}`;
};
